import { render, staticRenderFns } from "./single-printing.vue?vue&type=template&id=573dd54b&scoped=true&"
import script from "./single-printing.vue?vue&type=script&lang=ts&"
export * from "./single-printing.vue?vue&type=script&lang=ts&"
import style0 from "./single-printing.vue?vue&type=style&index=0&id=573dd54b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573dd54b",
  null
  
)

export default component.exports